import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import axios from 'axios';

// 1. GLOBAL BACKEND URL
axios.defaults.baseURL = 'https://family-tree-backend-1081894845006.asia-south1.run.app';

const GOOGLE_CLIENT_ID = "1081894845006-bid8qmr2repfp2ies4tcm7tpb0tqoao9.apps.googleusercontent.com"; 

// --- GLOBAL ERROR BOUNDARY ---
// Moved here to catch crashes inside the App component itself
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Critical Application Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', fontFamily: 'sans-serif', backgroundColor: '#FEF2F2', minHeight: '100vh', display: 'flex', justifyContent: 'center', items: 'center' }}>
          <div style={{ maxWidth: '600px', width: '100%', backgroundColor: 'white', padding: '2rem', borderRadius: '8px', border: '1px solid #FECACA', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <h1 style={{ color: '#DC2626', fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Application Error</h1>
            <p style={{ color: '#4B5563', marginBottom: '1rem' }}>Something went wrong while loading the application.</p>
            <div style={{ backgroundColor: '#F3F4F6', padding: '1rem', borderRadius: '4px', overflowX: 'auto', fontSize: '0.875rem', color: '#374151', marginBottom: '1.5rem' }}>
              {this.state.error && this.state.error.toString()}
            </div>
            <button 
              onClick={() => { localStorage.clear(); window.location.reload(); }} 
              style={{ width: '100%', padding: '0.75rem', backgroundColor: '#DC2626', color: 'white', border: 'none', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer' }}
            >
              Clear Cache & Reload
            </button>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {/* Wrap App in ErrorBoundary to catch root-level crashes */}
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </GoogleOAuthProvider>
  </React.StrictMode>
);